import { useQuery } from "@tanstack/react-query";
import { useApi, fmtDate } from "@/lib/api";

const KIND = {
  alert: ["Low-cash alert", "#FF5C7A"],
  board: ["Board update", "#00FF9D"],
  digest: ["Weekly digest", "#00C2FF"],
  limit_warning: ["AI limit heads-up", "#FFB800"],
};

const runwayText = (m) => (m == null ? "24+ mo" : `${Number(m).toFixed(1)} mo`);

export const EmailHistory = () => {
  const api = useApi();
  const { data = [] } = useQuery({ queryKey: ["email-history"], queryFn: () => api.get("/alerts/history") });
  return (
    <section data-testid="email-history" className="mt-4 rounded-xl border border-[#2A2A2A] bg-[#121212]">
      <div className="p-6 pb-3">
        <h3 className="font-display text-lg">Alert & email history</h3>
        <p className="text-sm text-[#A3A3A3]">Every alert, board update and digest sent, with who got it and the runway at that moment.</p>
      </div>
      {data.length === 0 ? (
        <p data-testid="email-history-empty" className="px-6 pb-6 text-sm text-[#A3A3A3]">Nothing sent yet.</p>
      ) : (
        <div className="overflow-x-auto">
          <p className="md:hidden px-6 pb-2 text-[11px] text-[#A3A3A3]">Swipe the table sideways to see the runway and recipients.</p>
          <table className="w-full text-sm">
            <thead className="text-[11px] uppercase tracking-wider text-[#A3A3A3] border-y border-[#2A2A2A]">
              <tr><th className="text-left px-6 py-2">Sent</th><th className="text-left px-3 py-2">Type</th><th className="text-left px-3 py-2">Runway then</th><th className="text-left px-3 py-2">Recipients</th></tr>
            </thead>
            <tbody className="divide-y divide-[#2A2A2A]">
              {data.map((e) => {
                const [label, color] = KIND[e.kind] || [e.kind, "#A3A3A3"];
                return (
                  <tr key={e.id} data-testid={`history-row-${e.id}`}>
                    <td className="pl-6 pr-3 py-3 font-mono text-xs">{new Date(e.sent_at).toLocaleString()}</td>
                    <td className="px-3 py-3 whitespace-nowrap">
                      <span className="inline-flex items-center gap-2"><span className="h-2 w-2 rounded-full" style={{ background: color }} />{label}</span>
                      {e.reason === "worse" && <span className="ml-2 text-[10px] text-[#FF8FA3]">got worse</span>}
                      {e.trigger && <span data-testid={`history-trigger-${e.id}`} className="ml-2 rounded-full border border-[#2A2A2A] px-1.5 py-0.5 text-[10px] text-[#A3A3A3]">{e.trigger}</span>}
                    </td>
                    <td className="px-3 py-3 font-mono text-xs whitespace-nowrap">
                      {runwayText(e.runway_months)}{e.zero_cash_date ? ` · ${fmtDate(e.zero_cash_date)}` : ""}
                      {e.threshold_months && <span className="text-[#A3A3A3]"> (level {e.threshold_months})</span>}
                    </td>
                    <td className="px-3 py-3 text-xs whitespace-nowrap">
                      {e.delivered_to.map((r) => <div key={r}>{r}</div>)}
                      {e.failed_count > 0 && <div data-testid={`history-failed-${e.id}`} className="text-[#FF5C7A]">{e.failed_count} not delivered</div>}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
};
